export default __webpack_public_path__ + "static/media/avaterStudent.2fcec55d.svg";